module.exports = __webpack_public_path__ + "static/media/beep-once-as.ef22cb69.mp3";